import React, { useEffect, useState } from "react";
import Webcam from "react-webcam";
import { Alert } from "../../components";

export const CustomCameraVideo = (props) => {
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);

  useEffect(() => {
    try {
      // console.log("props.Recording: ", props.Recording, webcamRef?.current)
      if (
        props.Recording &&
        webcamRef?.current != null &&
        webcamRef?.current != null
      ) {
        // console.log("Inicio props.Recording: ", props.Recording)
        setCapturing(true);
        mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream);
        // mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
        //   mimeType: "video/webm"
        // });
        mediaRecorderRef.current.addEventListener(
          "dataavailable",
          handleDataAvailable
        );
        mediaRecorderRef.current.start();
      }
    } catch (e) {
      console.log("Error: ", e);
      if (e instanceof Error) {
        const errorMessage = e.message; // Obtén el mensaje del error
        console.log("errorMessage: ", errorMessage);
        if (
          errorMessage.includes(
            "MediaRecorder constructor: Argument 1 is not valid for any of the 2-argument overloads"
          )
        ) {
          Alert(
            {
              icon: "error",
              title:
                "La cámara está en uso por otra aplicación. Por favor, verifica que no haya otra aplicación utilizando la cámara y vuelve a intentarlo.",
            },
            (event) => {
              props.setStopRecording(true);
            }
          );
        } else {
          console.log("El error no contiene el texto específico.", e);
        }
      } else {
        // En caso de que e no sea un objeto de Error
        console.log("Error inesperado:", e);
      }
    }
  }, [props.Recording, webcamRef, setCapturing, mediaRecorderRef]);

  useEffect(() => {
    // console.log("props.Stopped: ", props.Recording, mediaRecorderRef?.current)
    if (
      props.Stopped &&
      mediaRecorderRef?.current != undefined &&
      mediaRecorderRef?.current != null
    ) {
      // console.log("INIT props.Stopped: ", props.Stopped)
      mediaRecorderRef.current.stop();
      setCapturing(false);
    }
  }, [props.Stopped, mediaRecorderRef, webcamRef, setCapturing]);

  useEffect(() => {
    // console.log("props.Stopped:useEffect capturing ", capturing, recordedChunks.length)
    if (!capturing && recordedChunks.length > 0) {
      // console.log("INIT props.Stopped:capturing ", capturing)
      handleCapture();
    }
  }, [capturing, recordedChunks.length]);

  // const handleStartCaptureClick = React.useCallback(() => {
  //   setCapturing(true);
  //   mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
  //     mimeType: "video/webm"
  //   });
  //   mediaRecorderRef.current.addEventListener(
  //     "dataavailable",
  //     handleDataAvailable
  //   );
  //   mediaRecorderRef.current.start();
  // }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  // const handleStopCaptureClick = React.useCallback(() => {
  //   mediaRecorderRef.current.stop();
  //   setCapturing(false);
  // }, [mediaRecorderRef, webcamRef, setCapturing]);

  const handleCapture = React.useCallback(() => {
    // console.log("recordedChunks.length: ", recordedChunks.length)
    if (recordedChunks.length) {
      // console.log(" blob Capturar video: ", recordedChunks.length)
      const blob = new Blob(recordedChunks, {
        type: "video/webm",
      });

      props.onCapture(blob);

      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // document.body.appendChild(a);
      // a.style = "display: none";
      // a.href = url;
      // a.download = "react-webcam-stream-capture.webm";
      // a.click();
      // window.URL.revokeObjectURL(url);
      setRecordedChunks([]);
    }
  }, [recordedChunks]);

  // const [imgSrc, setImgSrc] = React.useState(null);

  // const capture = React.useCallback(() => {
  //   let base64 = webcamRef.current.getScreenshot();
  //   // console.log("imageSrc base64: ", base64)
  //   if (base64 != null && base64 != undefined) {
  //     base64 = base64.split(',')
  //     const blob = B64toBlob(base64[1], 'image/jpeg');
  //     props.onCapture(blob)
  //   }
  // }, [webcamRef]);

  // useEffect(() => {
  //   if (props.CaptureInit == true) {
  //     capture()
  //   }
  // }, [props.CaptureInit])

  return (
    <>
      {props.deviceId &&
      (navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/Android/i)) ? (
        <Webcam
          muted={true}
          audio={true}
          ref={webcamRef}
          screenshotQuality={1}
          style={
            props.isDisplay === false
              ? { display: "none" }
              : { display: "block" }
          }
          videoConstraints={{
            facingMode:
              props.FacingMode === undefined ||
              props.FacingMode === null ||
              props.FacingMode == ""
                ? "user"
                : props.FacingMode,
            width: parseInt(props.width),
            deviceId: props.deviceId,
          }}
          mirrored={
            props.Mirrored === undefined ||
            props.Mirrored == "" ||
            props.Mirrored === null
              ? navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/Android/i)
                ? true
                : false
              : props.Mirrored
          }
        />
      ) : (
        <Webcam
          muted={true}
          audio={true}
          ref={webcamRef}
          screenshotQuality={1}
          style={
            props.isDisplay === false
              ? { display: "none" }
              : { display: "block" }
          }
          videoConstraints={{
            facingMode:
              props.FacingMode === undefined ||
              props.FacingMode === null ||
              props.FacingMode == ""
                ? "user"
                : props.FacingMode,
            width: parseInt(props.width),
          }}
          mirrored={
            props.Mirrored === undefined ||
            props.Mirrored == "" ||
            props.Mirrored === null
              ? navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/Android/i)
                ? true
                : false
              : props.Mirrored
          }
        />
      )}

      {/* {capturing ? (
      <button onClick={handleStopCaptureClick}>Stop Capture</button>
    ) : (
      <button onClick={handleStartCaptureClick}>Start Capture</button>
    )}
    {recordedChunks.length > 0 && (
      <button onClick={handleDownload}>Download</button>
    )} */}
    </>
  );
};
